"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StaticContainer = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _theme = require("@tablekit/theme");

var _utils = require("@tablekit/utils");

var _themes = require("../themes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var slideIn = '0.3s cubic-bezier(0.77, 0.2, 0.05, 1)';
var StaticContainer = ( /*#__PURE__*/0, _styledBase["default"])('div', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['isOpen', 'position', 'width'].indexOf(prop) === -1;
  },
  target: "e1uukp0g0",
  label: "StaticContainer"
})("display:flex;flex-direction:column;position:fixed !important;transition:transform ", slideIn, ";", function (_ref) {
  var position = _ref.position;
  return "".concat(position, ": 0;");
}, ";", function (_ref2) {
  var isOpen = _ref2.isOpen,
      position = _ref2.position;

  if (position === 'bottom') {
    return "\n      left: 0;\n      transform: ".concat(isOpen ? 'translateY(0)' : 'translateY(110%)');
  }

  return "\n    top: 0;\n    transform: ".concat(isOpen ? 'translateX(0)' : "translateX(".concat(position === 'left' ? '-' : '', "110%)"));
}, ";", (0, _utils.mediaQuery)('width', function (value) {
  return "width: ".concat(value || '100%');
}), ";", (0, _utils.mediaQuery)('height', function (value) {
  return "height: ".concat(value || '100%');
}), ";", _theme.DEPTH.FIXED, ";background-color:", (0, _utils.getThemeValue)("".concat(_themes.panelThemeNamespace, ".backgroundColor"), _themes.panelClassicTheme.backgroundColor), ";z-index:", _theme.Z_INDICES.sidenav, ";box-shadow:0 6px 16px 0 rgba(0,0,0,0.1);" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.StaticContainer = StaticContainer;
StaticContainer.displayName = 'StaticPanelContainer';
var _default = {
  StaticContainer: StaticContainer
};
exports["default"] = _default;